import { sanitizeAndParseData } from '../../core/utils/sanitize-and-parse-data.js';
import {
  type RectDatapointInternal,
  type SeriesVariantType,
  type XYChartSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';
import type {
  AreaDatapoint,
  BarDatapoint,
  DotDatapoint,
  LineDatapoint,
} from '../types/xy-chart.js';

export type IsValidDatapoint = (
  type: SeriesVariantType,
  datapoint:
    | RectDatapointInternal
    | DotDatapoint
    | LineDatapoint
    | BarDatapoint
    | AreaDatapoint,
) => boolean;

export function formatCSV(
  data: XYChartSeriesWithDatapoints[],
  isValidDatapoint: IsValidDatapoint,
  getSeriesName: (series: XYChartSeriesWithDatapoints) => string,
) {
  const csvColumns = ['series', 'type', 'x0', 'x1', 'y0', 'y1', 'value'];

  let csv = `${csvColumns.join(',')}\n`;

  for (const series of data) {
    const seriesRow = [getSeriesName(series), series.type];

    for (const datapoint of series.data) {
      if (!isValidDatapoint(series.type, datapoint)) {
        continue;
      }
      const parsedX0 = sanitizeAndParseData(datapoint.x0);
      const parsedX1 = sanitizeAndParseData(datapoint.x1);
      const parsedY0 = sanitizeAndParseData(datapoint.y0);
      const parsedY1 = sanitizeAndParseData(datapoint.y1);
      const parsedValue = sanitizeAndParseData(
        'value' in datapoint ? datapoint.value : undefined,
      );
      const datapointsRow = [
        parsedX0,
        parsedX1,
        parsedY0,
        parsedY1,
        parsedValue,
      ];

      csv += `${seriesRow.concat(datapointsRow.toString()).join(',')}\n`;
    }
  }

  return csv;
}
